export type PathsType = keyof typeof paths
export const paths = {
  portal: (child?: string) => `/neighbourhood${child ? `/${child}` : ''}`,
  homeSearch: (
    mapType: 'map' | 'gallery' | string = 'map',
    saleType: 'lease' | 'sale' | string = 'sale',
  ) => `/home-search/${mapType}/${saleType}`,
}
